interface CircularLoaderProps {
  size?: number;

}

export function CircularLoader({ size = 50 }: CircularLoaderProps) {
  const loaderStyle = {
    width: size,
    height: size,
    border: `5px solid #0097B2`,
    borderTop: `${size / 10}px solid transparent`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  return (
    <div style={containerStyle}>
      <div style={loaderStyle}></div>
      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

